//Angular

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';
//System
import { Mappings} from '../../shared/mapping'

//Model
import { Company } from "./../../models/core/company";

//Services
import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';

@Injectable()
export class CompanyService {
      constructor(public _api: ApiService, public _cache: CacheService, private mappings: Mappings) {
     }

    getCompany(){
    let url =  this.mappings.Web_Api_Get_Default_Company;
    let key = url;

    return this._api.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/company.service.ts